import React, { FC } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';

export interface Props {
  id: string;
  enabled: boolean;
  placeholder: string | undefined;
  value: number | undefined;
  touched?: boolean;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<any>;
  rest?: Record<string, unknown>;
  minValue?: number;
  maxValue?: number;
  readOnlyMode?: boolean;
}

const NumericInput: FC<Props> = ({
  id,
  minValue,
  maxValue,
  value,
  touched,
  error,
  enabled,
  placeholder,
  onChange,
  onBlur,
  rest,
  readOnlyMode,
}: Props) => {
  return (
    <InputGroup>
      <FormControl
        type="number"
        min={minValue}
        max={maxValue}
        name={id}
        value={value}
        isValid={touched && !error}
        isInvalid={touched && !!error}
        disabled={!enabled || readOnlyMode}
        placeholder={readOnlyMode ? '' : placeholder}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
        onWheel={(e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()}
      />
    </InputGroup>
  );
};

export default NumericInput;
